import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
// Import Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// Add this line to import MDI
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    variations: {
      colors: [],
      lighten: 0,
      darken: 0,
    },
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#1867C0',     // main brand color
          secondary: '#5CBBF6',   // secondary color
          accent: '#FF4081',      // accent color
          error: '#FF5252',       // error color
          info: '#2196F3',        // info color
          success: '#4CAF50',     // success color
          warning: '#FFC107',     // warning color
          background: '#FFFFFF',   // background color
        },
        variables: {
          'field-input-padding-top': '0px',
          'input-padding-top': '0px',
        },
      },
      dark: {
        colors: {
          primary: '#2196F3',
          secondary: '#424242',
        },
        variables: {
          'field-input-padding-top': '0px',
          'input-padding-top': '0px',
        },
      }
    },
    typography: {
      h1: {
        fontSize: '1.75rem',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: '0.0075em',
      },
      h2: {
        fontSize: '1.5rem',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: '0.0075em',
      },
      h3: {
        fontSize: '1.25rem',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: '0.0075em',
      },
      body1: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
      },
      body2: {
        fontSize: '0.8125rem',
        fontWeight: 400,
        lineHeight: 1.43,
        letterSpacing: '0.01071em',
      },
      caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.66,
        letterSpacing: '0.03333em',
      },
    },
  },
  defaults: {
    VBtn: {
      size: 'small',
    },
    VTextField: {
      density: 'compact',
      variant: 'outlined',
      hideDetails: 'auto',
    },
    VSelect: {
      density: 'compact',
      variant: 'outlined',
      hideDetails: 'auto',
    },
    VTextarea: {
      density: 'compact',
      variant: 'outlined',
      hideDetails: 'auto',
    },
    VCard: {
      class: 'text-body-2'
    }
  },
})

const pinia = createPinia()
const app = createApp(App)

app
  .use(vuetify)
  .use(router)
  .use(pinia)
  .mount('#app')
